<template>
  <div>
    <v-navigation-drawer
      v-model="isOpen"
      :width="$isMobile ? '100%' : '50%'"
      right
      fixed
      :permanent="isOpen"
      hide-overlay
      class="z-index--100 pl-4"
      style="overflow: visible;">
      <div class="pa-3 content" style="overflow: auto; height: 100vh;">
        <div v-if="isOpen" class="d-flex">
          <v-btn
            dark
            fab
            small
            outlined
            color="primary"
            class="close mr-3"
            @click="closePanel"
            style="position: absolute; left: -20px; background-color: #fff; z-index: 100;"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </div>
        <div class="d-flex mt-6">
          <div class="titlePanel primary--text">
            {{ $t('expenses.bankReconciliation.transactions.relationsPanel.title') }}
          </div>

        </div>

          <!-- <div class="subtitle">
            {{ $t('expenses.bankReconciliation.transactions.relationsPanel.tableMovements.title') }}
          </div>
          <div v-if="tableMovements.data.length">
            <v-data-table
              v-model="tableMovements.selected"
              :loading-text="tableMovements.title"
              :loading="tableMovements.loading"
              :headers="tableMovements.headers"
              :items="tableMovements.data"
              :options="tableMovements.options"
              hide-default-footer
              class="relateTable"
              sort-by="date">
              <template v-slot:[`item._id`]="{ item }">
                <div>
                  {{ item._id }}
                </div>
              </template>
              <template v-slot:[`item.date`]="{ item }">
                <div>
                  {{ $moment(item.date).format('DD/MM/YYYY') }}
                </div>
              </template>
              <template v-slot:[`item.beneficiary`]="{ item }">
                <div>
                  {{ item.beneficiary }}
                </div>
              </template>
              <template v-slot:[`item.concept`]="{ item }">
                <div>
                  {{ item.concept }}
                </div>
              </template>
              <template v-slot:[`item.amount`]="{ item }">
                <div>
                  ${{ item.amount | toFix2 | numberWithComma }}
                </div>
              </template>
            </v-data-table>
          </div>
          <div v-else class="noInfo">
            {{ $t('expenses.bankReconciliation.transactions.relatePanel.noInfo') }}
          </div> -->

          <div class="subtitle">
            {{ $t('expenses.bankReconciliation.transactions.relationsPanel.tableOrders.title') }} - Total {{ totalAmountOrders | toFixNumber(2) | numberWithComma | prefix('$') }}
          </div>
          <div v-if="tableOrders.data.length">
            <v-data-table
              v-model="tableOrders.selected"
              :loading-text="tableOrders.title"
              :loading="tableOrders.loading"
              :headers="tableOrders.headers"
              :items="tableOrders.data"
              :options="tableOrders.options"
              hide-default-footer
              class="relateTable"
              :footer-props="{
                'items-per-page-options': [5, 10, 15]
              }"
              sort-by="date">
              <template v-slot:[`item._id`]="{ item }">
                <div>
                  <a @click="openPayOrderDetailsPanel(item)" class="link">{{ item._id }}</a>
                </div>
              </template>
              <template v-slot:[`item.date`]="{ item }">
                <div>
                  {{ $moment(item.date).format('DD/MM/YYYY') }}
                </div>
              </template>
              <template v-slot:[`item.paymentMethod`]="{ item }">
                <div>
                  {{ PAYORDER_PAYMENT_TYPES[item.paymentMethod] }}
                </div>
              </template>
              <template v-slot:[`item.status`]="{ item }">
                <div>
                  {{ STATUS_TYPES[item.status] }}
                </div>
              </template>
              <template v-slot:[`item.amount`]="{ item }">
                <div>
                  ${{ item.amount | toFix2 | numberWithComma }}
                </div>
              </template>
            </v-data-table>
          </div>
          <div v-else class="noInfo">
            {{ $t('expenses.bankReconciliation.transactions.relationsPanel.noInfo') }}
          </div>

          <div class="subtitle">
            {{ $t('expenses.bankReconciliation.relations.relatedTransactionsDialog.title') }} - Total {{ totalAmountBankTransactions | toFixNumber(2) | numberWithComma | prefix('$') }}
          </div>
          <div v-if="tableBankTransactions.data.length">
            <v-data-table
              v-model="tableBankTransactions.selected"
              :loading-text="tableBankTransactions.title"
              :loading="tableBankTransactions.loading"
              :headers="tableBankTransactions.headers"
              :items="tableBankTransactions.data"
              :options="tableBankTransactions.options"
              hide-default-footer
              :footer-props="{
                'items-per-page-options': [5, 10, 15]
              }"
              class="relateTable"
              sort-by="date">
              <template v-slot:[`item.date`]="{ item }">
                <div>{{ $moment(item.createdAt).format('DD/MM/YYYY') }}</div>
              </template>
              <template v-slot:[`item.description`]="{ item }">
                <div>{{ item.description }}</div>
              </template>
              <template v-slot:[`item.amount`]="{ item }">
                <div class="text-right">{{ item.amount | toFixNumber(2) | numberWithComma | prefix('$') }}</div>
              </template>
              <template v-slot:[`item.updatedBy`]="{}">
                <div>{{ updatedBy }}</div>
              </template>
            </v-data-table>
          </div>
          <div v-else class="noInfo">
            {{ $t('expenses.bankReconciliation.transactions.relationsPanel.noInfo') }}
          </div>

          <div class="grow"></div>
          <div class="d-flex justify-end buttonContainer">
            <Button
              size="regular"
              @click="closePanel">
              {{ $t('expenses.bankReconciliation.transactions.relationsPanel.buttonClose') }}
            </Button>
          </div>
      </div>
    </v-navigation-drawer>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <PayOrderDetails
    :isOpen.sync="payOrderDetailsPanelOpen"
    v-bind:selectedPayOrder="selectedPayOrder"
    @close="resetPayOrderDetails()" />
  </div>
</template>

<script>
import Button from '@/components/elements/Button'
import PayOrderDetails from '@/components/sidePanels/PayOrderDetails'
import isEmpty from 'lodash/isEmpty'

export default {
  name: 'BankMovementsRelations',
  props: {
    isOpen: Boolean,
    transaction: Object || Array,
    bankId: String,
    accountId: String
  },
  components: {
    Button,
    PayOrderDetails
  },
  emits: ['close'],
  data () {
    return {
      overlay: false,
      // tableMovements: {
      //   title: this.$i18n.t('expenses.bankReconciliation.transactions.relationsPanel.tableMovements.loading'),
      //   loading: false,
      //   headers: [
      //     { text: this.$i18n.t('expenses.bankReconciliation.transactions.relationsPanel.tableMovements.headers.id'), value: '_id', sortable: false },
      //     { text: this.$i18n.t('expenses.bankReconciliation.transactions.relationsPanel.tableMovements.headers.date'), value: 'date', sortable: false },
      //     { text: this.$i18n.t('expenses.bankReconciliation.transactions.relationsPanel.tableMovements.headers.author'), value: 'beneficiary', sortable: false },
      //     { text: this.$i18n.t('expenses.bankReconciliation.transactions.relationsPanel.tableMovements.headers.concept'), value: 'concept', sortable: false },
      //     { text: this.$i18n.t('expenses.bankReconciliation.transactions.relationsPanel.tableMovements.headers.amount'), value: 'amount', sortable: false }
      //   ],
      //   data: [],
      //   total: 0,
      //   itemsPerPage: 10,
      //   page: 1,
      //   selected: []
      // },
      tableOrders: {
        title: this.$i18n.t('expenses.bankReconciliation.transactions.relatePanel.loading'),
        loading: false,
        headers: [
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.relationsPanel.tableOrders.headers.id'), value: '_id', sortable: false },
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.relationsPanel.tableOrders.headers.date'), value: 'date', sortable: false },
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.relationsPanel.tableOrders.headers.paymentMethod'), value: 'paymentMethod', sortable: false },
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.relationsPanel.tableOrders.headers.status'), value: 'status', sortable: false },
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.relationsPanel.tableOrders.headers.amount'), value: 'amount', sortable: false }
        ],
        data: [],
        total: 0,
        itemsPerPage: 10,
        page: 1,
        selected: []
      },
      payOrderDetailsPanelOpen: false,
      selectedPayOrder: {},
      STATUS_TYPES: {
        created: this.$i18n.t('expenses.bankReconciliation.transactions.relationsPanel.statusTypes.created'),
        pending_payment: this.$i18n.t('expenses.bankReconciliation.transactions.relationsPanel.statusTypes.pendingPayment'),
        paid: this.$i18n.t('expenses.bankReconciliation.transactions.relationsPanel.statusTypes.paid')
      },
      PAYORDER_PAYMENT_TYPES: {
        balance: this.$i18n.t('expenses.bankReconciliation.transactions.relationsPanel.paymentTypes.balance'),
        credit: this.$i18n.t('expenses.bankReconciliation.transactions.relationsPanel.paymentTypes.credit')
      },
      invoice: {
        data: [],
        loading: false
      },
      tableBankTransactions: {
        loadingText: this.$i18n.t('expenses.bankReconciliation.relations.relatedTransactionsDialog.table.loadingText'),
        loading: false,
        headers: [
          { text: this.$i18n.t('expenses.bankReconciliation.relations.relatedTransactionsDialog.table.headers.date'), value: 'date', sortable: false },
          { text: this.$i18n.t('expenses.bankReconciliation.relations.relatedTransactionsDialog.table.headers.description'), value: 'description', sortable: false },
          { text: this.$i18n.t('expenses.bankReconciliation.relations.relatedTransactionsDialog.table.headers.amount'), value: 'amount', sortable: false },
          { text: this.$i18n.t('expenses.bankReconciliation.relations.relatedTransactionsDialog.table.headers.editor'), value: 'updatedBy', sortable: false }
        ],
        data: [],
        total: 0,
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: -1,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: [],
          sortDesc: []
        }
      },
      tableRelations: {
        loadingText: this.$i18n.t('expenses.bankReconciliation.relations.tableRelations.loadingText'),
        loading: false,
        headers: [
          { text: this.$i18n.t('expenses.bankReconciliation.relations.tableRelations.headers.id'), value: '_id', sortable: false },
          { text: this.$i18n.t('expenses.bankReconciliation.relations.tableRelations.headers.date'), value: 'date', sortable: true },
          { text: this.$i18n.t('expenses.bankReconciliation.relations.tableRelations.headers.modifiedBy'), value: 'updatedBy', sortable: true },
          { text: this.$i18n.t('expenses.bankReconciliation.relations.tableRelations.headers.transactions'), value: 'bankTransactionsTotal', sortable: true },
          { text: this.$i18n.t('expenses.bankReconciliation.relations.tableRelations.headers.orders'), value: 'ordersTotal', sortable: true },
          { text: this.$i18n.t('expenses.bankReconciliation.relations.tableRelations.headers.movements'), value: 'transfersTotal', sortable: true },
          { text: '', value: 'total', sortable: false }
        ],
        data: [],
        total: 0,
        selected: [],
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: 10,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: ['date'],
          sortDesc: ['desc']
        }
      }
    }
  },
  watch: {
    transaction: async function () {
      this.transaction && await this.load()
    }
  },
  computed: {
    open: {
      get: function () {
        return this.isOpen
      },
      set: function (newValue) {
        this.$emit('update:isOpen', newValue)
      }
    },
    restaurant () {
      return this.$store.state.currentRestaurant.data
    },
    totalAmountOrders () {
      return this.tableOrders.data.reduce((acc, num) => {
        return acc + num.amount
      }, 0)
    },
    totalAmountBankTransactions () {
      return this.tableBankTransactions.data.reduce((acc, num) => {
        return acc + num.amount
      }, 0)
    }
  },
  mounted () {
    window.addEventListener('keydown', this.keyDownHandler)
  },
  destroyed () {
    window.removeEventListener('keydown', this.keyDownHandler)
  },
  methods: {
    keyDownHandler (event) {
      if (event.code === 'Escape') {
        this.resetForm()
        this.$emit('close')
      }
    },
    load: async function () {
      (this.transaction.transfers || this.transaction.orders) && await this.loadTransactionsRelations()
      await this.loadRelations()
      await this.loadBankTransactions()
    },
    async loadTransactionsRelations (params = null) {
      params = params || {}
      // this.tableMovements.loading = true
      this.tableOrders.loading = true
      try {
        const response = await this.$api.get(`/v1/banks/transactions/${this.transaction._id}`)
        // this.tableMovements.data = response.transfers
        this.tableOrders.data = response.orders
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      // this.tableMovements.loading = false
      this.tableOrders.loading = false
    },
    resetForm () {
      // this.tableMovements.data = []
      this.tableOrders.data = []
    },
    closePanel () {
      this.resetForm()
      this.$emit('close')
    },
    openPayOrderDetailsPanel (item) {
      this.selectedPayOrder = item
      this.payOrderDetailsPanelOpen = true
    },
    resetPayOrderDetails () {
      this.selectedPayOrder = {}
    },
    loadRelations: async function () {
      this.tableRelations.loading = true
      const params = {
        restaurant: this.restaurant._id,
        bank: this.bank,
        finerioUnitAccount: this.account || undefined,
        bankTransactions: this.transaction.id
      }
      try {
        const response = await this.$api.get(`/v1/bank-reconciliation`, params)
        this.tableRelations.data = response.data
        this.relation = this.tableRelations.data[0]._id
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.tableRelations.loading = false
    },
    async loadBankTransactions () {
      this.tableBankTransactions.loading = true
      try {
        const response = await this.$api.get(`/v1/bank-reconciliation/${this.relation}/bank-transactions`)
        this.tableBankTransactions.data = !isEmpty(response.data) ? response.data[0].bankTransactions : []
        this.updatedBy = (!isEmpty(response.data) && response.data[0].updatedBy) ? response.data[0].updatedBy.email : undefined
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.tableBankTransactions.loading = false
    }
  }
}
</script>

<style lang="scss">
  .content {
    overflow: visible;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .titlePanel {
    font-weight: 500;
    font-size: 28px;
    line-height: 33px;
  }

  .subtitle {
    padding-top: 40px;
    padding-bottom: 20px;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: #646464;
  }

  .relateTable tr {
    border: 1px solid #ACABAB;
    border-radius: 7px;
  }

  .relateTable td:first-child {
    border-left: 1px solid #ACABAB;
    border-top-left-radius: 7px;
    border-bottom-left-radius: 7px;
  }

  .relateTable td {
    border-top: 1px solid #ACABAB;
    border-bottom: 1px solid #ACABAB;
  }

  .relateTable td:last-child {
    border-right: 1px solid #ACABAB;
    border-top-right-radius: 7px;
    border-bottom-right-radius: 7px;
  }

  .relateTable thead tr:last-child th {
    border-bottom: none !important;
  }

  .noInfo {
    border: 1px solid #ACABAB;
    border-radius: 7px;
    padding-top: 22px;
    padding-bottom: 22px;
    text-align: center;
    line-height: 19px;
    color: #ACABAB;
  }

  .theme--light.v-icon {
    color: inherit;
  }

  .grow {
    flex-grow: 1
  }

  .buttonContainer {
    margin-bottom: 80px;
  }

  .link:hover {
    text-decoration: underline;
    color: #3366BB !important;
  }

</style>
